import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, certissueActions, certapplyActions } from '../../../../store/actions'
import moment from 'moment'
import Input from '../../../../module/input'
/*import Calendar from '../../../../../module/calendar'*/
import { commons } from '../../../../hook/common'
import Alert from '../../../../module/alert'

/**
 * 결제하기 팝업
 * @param props
 * @constructor
 */
const PopSett = (props) => {
  let userInfo = JSON.parse(localStorage.getItem('user'))
  const [state, setState] = useState({
    cancelMsg: '',
    cancelMsgAlert: '',
    submitted: false,
    memberId: userInfo.payload.memberId,
  })
  const [isEdit, setIsEdit] = useState(false)
  const [input, setInput] = useState({})

  const handleClose = () => {
    props.onClose()
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value,
    })
    //console.log(state.cancelMsg.length);
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const { cancelMsg } = state

    if (!cancelMsg) return props.error({ message: '취소사유를 입력해주세요.' })

    setState({
      ...state,
      submitted: true,
    })
    const data = new FormData(document.getElementById('cancelForm'))
    props.cancelSubmit(data)
  }

  /*   function reqCancel() {
    let errCnt = 0
    if (state.cancelMsg.length <= 0) {
      setState({ ...state, cancelMsgAlert: '취소사유를 입력해주세요.' })
      errCnt++
    }
     if (errCnt > 0) {
      return
    } 

    const data = new FormData(document.getElementById('cancelForm'));
    props.cancelSubmit(data);
  } */

  let style = {
    backgroundColor: 'rgb(0, 0, 0)',
    position: 'fixed',
    inset: '0px',
    opacity: '0.6',
    zIndex: '1',
  }

  let styleModal = {
    position: 'absolute',
    opacity: '1',
    zIndex: '2',
    display: 'block',
  }

  useEffect(() => {
    if (props.CancelResult !== undefined) {
      console.log('CancelResult result', props.CancelResult)
      props.success({
        title: '확인',
        message: '결제취소 신청이 완료되었습니다.',
        params: {
          type: 'success',
          callback: () => {
            //window.location.replace('/service/certissue');
            window.location.reload()
          },
        },
      })
      //CancelPay()
      //props.onClose()
    }
  }, [props.CancelResult])

  const CancelPay = () => {
    //console.log('alert')
    alertActions.success({
      title: '확인',
      message: '결제취소 신청이 완료되었습니다.',
      params: {
        type: 'success',
        callback: () => {
          //window.location.replace('/service/certissue');
          window.location.reload()
        },
      },
    })
  }

  return (
    <React.Fragment>
      {/* 결제취소하기 */}
      <div style={style}></div>
      <div style={styleModal} id="purchase-register" className="modal w1120">
        <div className="modal-head">
          <h3 className="h3-tit first">{props.viewNm}</h3>
        </div>
        <div className="modal-cont">
          <form name="cancelForm" id="cancelForm" onSubmit={handleSubmit}>
            <input type="hidden" name="TID" value={props.dlngId} /> {/* <!-- 거래ID --> */}
            <input type="hidden" name="CancelAmt" value={props.stlmAmt} /> {/* <!-- 취소금액 --> */}
            <input type="hidden" name="PartialCancelCode" value="0" /> {/* <!-- 전체취소 --> */}
            <input type="hidden" name="MID" value="nicepay00m" readOnly={true} /> {/* 상점아이디 */}
            <input type="hidden" name="MOID" value={props.stlmOrdrNo} /> {/* <!-- 상점주문번호 --> */}
            <input type="hidden" name="memberId" value={state.memberId} /> {/* <!-- 상점주문번호 --> */}
            <table className="tbl-write">
              <caption>주문 번호, 상품명, 취소금액, 취소사유 항목으로 구성</caption>
              <colgroup>
                <col className="col1" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">주문 번호</th>
                  <td>{props.stlmOrdrNo}</td>
                </tr>
                <tr>
                  <th scope="row"> 상품명</th>
                  <td>{props.crtNm}</td>
                </tr>
                <tr>
                  <th scope="row"> 취소금액</th>
                  <td>{commons.addComma(Number(props.stlmAmt))} 원</td>
                </tr>
                <tr>
                  <th scope="row">취소사유</th>
                  <td>
                    <fieldset>
                      <Input
                        type={'text'}
                        id="cancelMsg"
                        name="cancelMsg"
                        value={state.cancelMsg}
                        className="form-control input-text"
                        placeholder="취소사유"
                        message={'취소사유 입력하세요'}
                        onChange={(e) => handleChange(e)}
                        required={true}
                        numberOnly={false}
                        inputTitle={'취소사유 입력'}
                        submitted={state.submitted}
                      />
                    </fieldset>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="btn-block center">
              <button type="submit" className="btn-primary lg w200" /* onClick={reqCancel} */>
                취소요청
              </button>
            </div>
          </form>
        </div>
        <button type="button" className="modal-close b-close" onClick={handleClose}>
          창닫기
        </button>
      </div>
      {/* 결제하기 */}
      {/* <Alert/> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    settData: state.certissue?.data,
    isCalled: state.certissue.isCalled,
    isFailure: state.certissue.isFailure,
    CancelResult: state.certapply?.CancelResult,
  }
}

const actionCreators = {
  saveSett: certissueActions.saveStep,
  setCalled: certissueActions.setCalled,
  error: alertActions.error,
  confirm: alertActions.confirm,
  success: alertActions.success,
  cancelSubmit: certapplyActions.cancelSubmit,
}

export default connect(mapStateToProps, actionCreators)(PopSett)
